export default {
  data() {
    return {
      metrics: [],
      groupMetrics: [],
      selectedGroupMetValues: [],
      selectedMetrics: [],
      metricKey: 0,
      showMetricsComponent: true,
      hasMetricsOccurrences: false,
      hasMetricsVideos: false,
      incompatibleDimensionsMetrics: [
        {
          metric: 'AIR Engagement Rate',
          dimension: 'AIR Engagement Reporting Label'
        },
        {
          metric: 'CELT Unit engagement rate',
          dimension: 'CELT Engagement Reporting label'
        }
      ],
      hasIncompatibleMetrics: false,
    }
  },
  methods: {
    onDragEndMetrics() {
      this.selectedMetrics = this.selectedGroupMetValues.map(item => item.name)
    },
    resetMetricsMultiselect() {
      this.metricKey += 1
    },
    resetMetricsData() {
      this.selectedGroupMetValues = [...this.selectedGroupMetValues]
      this.groupMetrics = [...this.groupMetrics]
      this.$nextTick(() => {
        if (this.$refs.metricsMultiselect) {
          this.$refs.metricsMultiselect.$forceUpdate()
        }
      })
    },
    reloadMetricsComponent() {
      this.showMetricsComponent = false
      this.$nextTick(() => {
        this.showMetricsComponent = true
      })
    },
    loadMetrics(metricsString) {
      const metricIds = metricsString.split(',')
      this.selectedGroupMetValues = []
      this.selectedMetrics = []
      metricIds.forEach(id => {
        this.groupMetrics.every(group => {
          const metric = group.data.find(m => m.id == id)
          if (metric) {
            this.selectedGroupMetValues.push(metric)
            this.selectedMetrics.push(metric.name)
            return false
          }
          return true
        })
      })
    },
    addToGroupMetrics(metric) {
      const vendor = metric.name.split(' ')[0]
      let group = this.groupMetrics.find(g => g.vendor === vendor)
      if (!group) {
        group = { vendor, data: [] }
        this.groupMetrics.push(group)
      }
      group.data.push({ name: metric.name, id: metric.id })
    },
    syncSelectedMetrics(values) {
      this.selectedMetrics = values.map(item => item.name)
      this.updateMetricsFlags()
    },
    updateMetricsFlags() {
      const occurrencesM = [
        'AIR Event Occurrences',
        'AIR User Initiated Event Occurrences'
      ]
      const videoM = [
        'AIR Video Starts',
        'AIR Video Completions',
        'AIR Video Plays',
        'AIR Video Play Time',
        'AIR Video First Quartile View',
        'AIR Video Second Quartile View',
        'AIR Video Third Quartile View',
        'AIR Video Fourth Quartile View'
      ]

      this.hasMetricsOccurrences = this.selectedMetrics.some(m => occurrencesM.includes(m))
      this.hasMetricsVideos = this.selectedMetrics.some(m => videoM.includes(m))
    },
    onSelectedMetrics(selected) {
      this.selectedGroupMetValues = selected
      this.syncSelectedMetrics(selected)
    },
    removeMetric(value) {
      const index = this.selectedGroupMetValues.indexOf(value)
      this.selectedGroupMetValues.splice(index, 1)
      this.syncSelectedMetrics(this.selectedGroupMetValues)
    },
    checkIncompatibleMetrics() {
      this.hasIncompatibleMetrics = (
        (this.selectedMetrics.includes(this.incompatibleDimensionsMetrics[0].metric) &&
          this.selectedDimensions.includes(this.incompatibleDimensionsMetrics[0].dimension)) ||
        (this.selectedMetrics.includes(this.incompatibleDimensionsMetrics[1].metric) &&
          this.selectedDimensions.includes(this.incompatibleDimensionsMetrics[1].dimension))
      )
    },
    vendorLabel(option) {
      if (!option.$isLabel) {
        return option.name.split(' ')[0]
      }
      return option.$groupLabel
    },
    vendorLabelDisplay(option, all = '') {
      if (!option.$isLabel) {
        const lvalue = option.name.split(' ')[0].length
        return option.name.substring(lvalue, option.name.length)
      } else {
        return `${all}`
      }
    },
    initializeMetrics(metrics) {
      this.metrics = metrics
      this.buildGroupMetrics()
    },
    buildGroupMetrics() {
      this.metrics.forEach(metric => {
        this.addToGroupMetrics(metric)
      })
    }
  },
  watch: {
    selectedMetrics: function() {
      this.checkIncompatibleMetrics()
    },
    selectedDimensions: function() {
      this.checkIncompatibleMetrics()
    },
    isSavedReport: function (newVal) {
      if (!newVal) {
        this.newReportName = ''
        this.$forceUpdate()
        this.resetMetricsMultiselect()
        this.resetMetricsData()
        this.reloadMetricsComponent()
      }

      if (!this.isInitialLoad && newVal) {
        this.newReportName = this?.selectedTemplateReportData?.name || ''
      }
    },
  }
}
